import React from "react";

import { Grid, Card, CardContent, Typography, Box } from "@mui/material";
import {
  Business,
  Person,
  TrendingUp,
  BarChart,
} from "@mui/icons-material";

export const FranchiseAnalyticsCards = ({ report }) => {
  if (!report?.summary) return null;

  const cards = [
    {
      title: "Total de Unidades",
      value: report.summary.totalFranchises,
      icon: Business,
      color: "var(--primary-color)",
    },
    {
      title: "Membros Ativos",
      value: report.summary.totalCreators,
      icon: Person,
      color: "var(--success-color)",
    },
    {
      title: "Posts por Membros em Unidades",
      value: report.summary.totalPosts,
      icon: BarChart,
      color: "var(--secondary-color)",
    },
  ];

  return (
    <Grid container spacing={3} sx={{ mb: 4 }}>
      {cards.map((card, index) => (
        <Grid item xs={12} sm={6} md={4} lg={2} key={index}>
          <Card
            sx={{
              height: "100%",
              transition: "transform 0.2s ease-in-out",
              "&:hover": {
                transform: "translateY(-4px)",
                boxShadow: 3,
              }
            }}
          >
            <CardContent sx={{ textAlign: "center", p: 2 }}>
              <Box sx={{ display: "flex", justifyContent: "center", mb: 1 }}>
                <card.icon
                  sx={{
                    fontSize: 40,
                    color: card.color,
                  }}
                />
              </Box>
              <Typography
                variant="h4"
                sx={{
                  mb: 1,
                  color: card.color,
                  fontWeight: "bold",
                  fontSize: { xs: "1.5rem", sm: "2rem" }
                }}
              >
                {card.value}
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  fontWeight: 500,
                  lineHeight: 1.2,
                  minHeight: "2.4em",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {card.title}
                {card.subtitle && (
                  <Box component="span" sx={{ display: "block", fontSize: "0.75rem", mt: 0.5 }}>
                    {card.subtitle}
                  </Box>
                )}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};
